import {useQuery} from "@tanstack/react-query";
import {getWalletService} from "./wallet.service";
import type {Wallet} from "./wallet.types";

export const WALLET_QUERY_KEY = ["wallet"] as const;

export interface UseWalletResult {
  wallet: Wallet | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useWallet = (): UseWalletResult => {
  const query = useQuery<Wallet, Error>({
    queryKey: WALLET_QUERY_KEY,
    queryFn: getWalletService,
    staleTime: 60_000,
  });

  return {
    wallet: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
